var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "flex-start",
          "overflow-x": "auto",
          "scrollbar-width": "none",
        },
      },
      _vm._l(_vm.dataList, function (item, index) {
        return _c(
          "div",
          { key: index, staticStyle: { "margin-right": "5px" } },
          [
            _c("el-image", {
              style: {
                display: "block",
                height: item.bannerPic ? "" : "30px",
                width: item.bannerPic ? "100%" : "",
              },
              attrs: {
                src: item.bannerPic
                  ? item.bannerPic
                  : require("@/assets/customPage/" +
                      _vm.$props.itemDetail.componentCode +
                      ".png"),
                fit: "cover",
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }